import React, { Component } from 'react';
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import * as Highcharts from 'highcharts';
import CSSModules from "react-css-modules";
import { Button, Drawer, Select, MenuItem, Modal, TextField } from "@material-ui/core";
import { Close, DateRange } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
import { shouldUpdate } from "../../utils";

import comment_add_icon from "../../assets/Icons/comment_add.png";
import comment_list_icon from "../../assets/Icons/comment_list.png";

import Tooltip, { TooltipContent } from "../../components/Tooltip/tooltip";

import styles from "./styles.scss";

// adds Comment buttons to a chart
@CSSModules(styles, { allowMultiple: true })
class ChartComment extends Component {
    state = {
    }

    componentDidMount() {
        this._setup();
    }
    render() {
        return (
            <div style={{position: 'absolute', top: 0, right: 0, zIndex: 100}}>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', position: 'relative' }}>
                    <Tooltip delay={50}>
                        <div>
                            <div onClick={() => this._addCommentClick()} style={{position: 'absolute', right: this.props.commentList.length > 0 ? 50 : 10, zIndex: 100, cursor: 'pointer'}}>
                                <div style={{width: 28, height: 25, position: 'relative'}}>
                                    <img src={comment_add_icon} alt="add comment" style={{height: 25, width: 28}} />
                                </div>
                            </div>
                        </div>
                        <TooltipContent>
                            <div styleName="rrule-failed-tooltip">
                                Add a new comment
                            </div>
                        </TooltipContent>
                    </Tooltip>
                    {
                        this.props.commentList !== undefined && this.props.commentList.length > 0 &&
                        <Tooltip delay={50}>
                            <div>
                                <div onClick={() => this._listCommentsClick()} style={{position: 'absolute', right: 10, zIndex: 100, cursor: 'pointer'}}>
                                    <div style={{width: 28, height: 25, position: 'relative'}}>
                                        <img src={comment_list_icon} alt="comment list" style={{height: 25, width: 28}} />
                                        <div style={{position: 'absolute', top: -2, right: -2, borderRadius: 100, backgroundColor: '#526BAF', color: '#FFF', fontSize: 11, lineHeight: '12px'}}>
                                            <div style={{width: 18, height: 18, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{this.props.commentList.length}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <TooltipContent>
                                <div styleName="rrule-failed-tooltip">
                                    List all comments
                                </div>
                            </TooltipContent>
                        </Tooltip>
                        
                        
                    }
                </div>
                {
                    this.props.isChartOn &&
                    <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', position: 'relative'}}>
                        <div style={{marginTop: 44, fontSize: 16, fontWeight: 600, color: '#F00'}}>Click on the Chart where you want your comment.</div>
                    </div>
                }
            </div>
        )
    }
    _setup() {
        if (this.props.chart == null) return;
        if (this.props.chart.current == null) return;

        const chart = this.props.chart.current.getChart();

        this._setupChart(chart);

        this.props.getCommentList(this.props.selectedRuleInstance.ruleInstanceId, this.props.timePeriod.startDate, this.props.timePeriod.endDate);
    }
    _addCommentClick() {
        this.props.addCommentClick();
    }
    _listCommentsClick() {
        this.props.listCommentsClick();
    }
    _setupChart(chart) {
        Highcharts.removeEvent(chart, 'click');
        Highcharts.addEvent(chart, 'click', this._chartClick);
    }
    _chartClick(e) {
        this.props.chart.current.chart.pointer.normalize(e);

        let extremes = this.props.chart.current.chart.yAxis[0].getExtremes();
        let y = Math.floor(this.props.chart.current.chart.yAxis[0].toValue(e.chartY));
    
        var range = extremes.max - extremes.min;
        var perc = Math.floor(((y - extremes.min) / range) * 100);

        let x = Math.floor(this.props.chart.current.chart.xAxis[0].toValue(e.chartX));

        console.log("CHART CLICKED: " + x + ", " + y);

        this.props.chartClicked(x, Math.abs(perc));
    }
}

const bindAction = dispatch => {
    return {
        addCommentClick: () => dispatch(actions.addCommentClick()),
        addCommentClose: () => dispatch(actions.addCommentClose()),
        listCommentsClick: () => dispatch(actions.listCommentsClick()),
        listCommentsClose: () => dispatch(actions.listCommentsClose()),
        addCommentViaChartClick: () => dispatch(actions.addCommentViaChartClick()),
        addCommentViaChartClose: () => dispatch(actions.addCommentViaChartClose()),
        addCommentViaGenericClose: () => dispatch(actions.addCommentViaGenericClose()),
        addCommentViaGenericClick: () => dispatch(actions.addCommentViaGenericClick()),
        getCommentList: (r, f, t) => dispatch(actions.getCommentList(r, f, t)),

        chartClicked: (x, y) => dispatch(actions.chartClicked(x, y)),

        navigate: (uri, data) => dispatch(router.push(uri, data)),
    };
};

const mapStateToProps = (state, ownProps) => ({
    addCommentOpen: state.chartcomment.addCommentOpen,
    listCommentsOpen: state.chartcomment.listCommentsOpen,
    addCommentViaChartOpen: state.chartcomment.addCommentViaChartOpen,
    addCommentViaGenericOpen: state.chartcomment.addCommentViaGenericOpen,

    commentList: state.chartcomment.commentList,
    selectedRuleInstance: state.ruleinstancesearch.selectedRuleInstance,
    isChartOn: state.chartcomment.isChartOn,

    errors: state.chartcomment.errors,
});

export default connect(mapStateToProps, bindAction)(ChartComment);


// WEBPACK FOOTER //
// ./src/components/ChartComment/ChartComment.js